import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import {
  selectCurrentVariantCohort,
  selectLanguage,
} from 'root-redux/selects/common'
import { selectUUID, selectUserCountryCode } from 'root-redux/selects/user'

import { setSentryScope } from 'helpers/sentryScope'

export const useSentryScope = (): void => {
  const uuid = useSelector(selectUUID)
  const cohort = useSelector(selectCurrentVariantCohort)
  const language = useSelector(selectLanguage)
  const country = useSelector(selectUserCountryCode)

  useEffect(() => {
    setSentryScope({ uuid, cohort, language, country })
  }, [uuid, cohort, language, country])
}
